var render = function () {
  var _vm$recruitment, _vm$recruitment2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "tit"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit grey-c--text"
  }, [_vm._v("채용관리")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "tit__line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit grey-c--text"
  }, [_vm._v(_vm._s((_vm$recruitment = _vm.recruitment) === null || _vm$recruitment === void 0 ? void 0 : _vm$recruitment.subject))])]), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "tit__line"
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v("합격자 관리")])])], 1)], 1), _c('template', {
    slot: "contents"
  }, [_c('v-row', {
    staticClass: "mb-n4 mb-md-12",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-badge', {
    staticClass: "v-badge--btn",
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow mr-4 mr-lg-8"
  }), _c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("합격자 지원 관리")])])], 1)], 1), _c('v-col', {
    staticClass: "mb-12 mb-lg-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify-lg": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--text-fit",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.toggleAllSelected
    }
  }, [_c('v-simple-checkbox', {
    attrs: {
      "value": _vm.isAllSelected
    },
    on: {
      "click": _vm.toggleAllSelected
    }
  }), _vm._v(" 전체선택 ")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "auto"
    }
  }, [_c('meeting-view', {
    attrs: {
      "value": {
        recruitment: _vm.recruitment,
        applications: _vm.selected
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "w-100 w-md-160px",
          attrs: {
            "outlined": "",
            "small": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey-6--text"
        }, [_vm._v(" 선택항목 미팅요청 "), _c('v-icon', {
          staticClass: "ml-4",
          attrs: {
            "size": "18"
          }
        }, [_vm._v("mdi-calendar")])], 1)])];
      }
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "auto"
    }
  }, [_c('texting-dialog', _vm._b({
    attrs: {
      "applications": _vm.recruits,
      "paramsProps": {
        _recruitment: _vm._recruitment
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "w-100 w-md-160px",
          attrs: {
            "outlined": "",
            "small": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey-6--text"
        }, [_vm._v(" 선택항목 문자발송 "), _c('v-icon', {
          staticClass: "ml-4",
          attrs: {
            "size": "18"
          }
        }, [_vm._v("mdi-email-outline")])], 1)])];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'texting-dialog', {
    recruitment: _vm.recruitment
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "auto"
    }
  }, [_c('application-excel-btn', _vm._b({
    staticClass: "w-100 w-md-160px",
    attrs: {
      "fileName": "".concat((_vm$recruitment2 = _vm.recruitment) === null || _vm$recruitment2 === void 0 ? void 0 : _vm$recruitment2.subject, "_\uD569\uACA9\uC790_\uBAA9\uB85D"),
      "small": "",
      "dark": "",
      "color": "green"
    }
  }, 'application-excel-btn', {
    selected: _vm.selected
  }, false), [_c('span', [_vm._v(" 엑셀파일 다운로드 "), _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-tray-arrow-down")])], 1)])], 1)], 1)], 1), _c('v-spacer')], 1), _c('div', {
    staticClass: "v-cards"
  }, _vm._l(_vm.recruits, function (value) {
    return _c('recruit-list-item', _vm._b({
      key: value === null || value === void 0 ? void 0 : value._id,
      on: {
        "input": _vm.updateItem,
        "updateSelected": function updateSelected(value) {
          return _vm.selected = value;
        }
      }
    }, 'recruit-list-item', {
      value: value,
      selected: _vm.selected,
      recruitment: _vm.recruitment
    }, false));
  }), 1), !_vm.recruits.length ? [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 합격자가 없습니다. ")]), _c('v-btn', {
    attrs: {
      "text": "",
      "height": "auto",
      "color": "transparent"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용리스트 돌아가기")])])], 1)] : _vm._e()], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }